import { Component, computed, contentChild, input, output, signal } from '@angular/core';
import { ModalFooterDirective } from './directives/modal-footer.directive';

@Component({
  selector: 'app-modal-v2',
  imports: [],
  templateUrl: './modal-v2.component.html',
  styleUrl: './modal-v2.component.css',
})
export class ModalV2Component {
  private readonly _footerContent = contentChild(ModalFooterDirective);

  protected readonly hasFooter = computed(() => !!this._footerContent());
  protected readonly shake = signal(false);

  public readonly title = input.required<string>();
  public readonly titleColorClass = input('text-sidebar-text dark:text-sidebar-text-dark');
  public readonly maxWidthClass = input('max-w-lg');
  public readonly open = input<boolean>(false);
  public readonly showCloseButton = input<boolean>(true);
  public readonly allowOutsideClick = input<boolean>(false);
  public readonly showFooterSeparator = input<boolean>(true);
  public readonly closed = output<void>();

  protected close(): void {
    this.closed.emit();
  }

  protected onBackdropClick(): void {
    if (this.allowOutsideClick()) {
      this.close();
    } else {
      this._triggerShake();
    }
  }

  private _triggerShake(): void {
    this.shake.set(false);
    requestAnimationFrame(() => this.shake.set(true));
  }
}
